// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Antd from 'ant-design-vue';
import App from './App'
import router from './router'
import axios from 'axios'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import store from './store'
import qs from 'qs'
import less from 'less'
Vue.use(less)
Vue.use(VueAwesomeSwiper)

// import 'ant-design-vue/dist/antd.css';
import 'ant-design-vue/dist/antd.less';

// import './css/theme.less';
Vue.config.productionTip = false
Vue.use(Antd);

import api from './utils/api'
Vue.prototype.api = api //接口
Vue.prototype.img = "/api/file/preview/" //图片地址

// 请求拦截器
axios.interceptors.request.use((config) => {
    if (config.method === 'get') {
        config.paramsSerializer = params => {
            return qs.stringify(params, { arrayFormat: 'repeat' })
        }
    }
    return config
}, (error) => {
    return Promise.reject(error)
})

// 响应拦截器
axios.interceptors.response.use((response) => {
    return response
}, (error) => {
    return Promise.reject(error)
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js